import { App as AntApp, ConfigProvider } from "antd";
import { Suspense } from "react";
import { Route, Routes } from "react-router";
import type { TUserRoles } from "./app/app.constants";
import AuthGuard from "./components/AuthGuard";
import Seo from "./components/common/Seo";
import useAppBoot from "./hooks/useAppBoot";
import useAuth from "./hooks/useAuth";
import Loader from "./pages/Loader";
import NotFound from "./pages/NotFound";
import TopPromotionBar from "./pages/user/userDiscount/_components/TopPromotionBar";
import { APP_ROUTES, PUBLIC_ROUTES } from "./routes/routes";
import { antdThemeDark, antdThemeLight } from "./theme/theme";
import { filterRoutesByRole, flattenRoutes } from "./utils/global.utils";
const App = () => {
  const { role, theme } = useAuth();
  const { loading } = useAppBoot();

  const accessibleRoutes = filterRoutesByRole(APP_ROUTES, role as TUserRoles);
  const flatRoutes = flattenRoutes(accessibleRoutes);

  // console.log(ENV_CONFIG.AUTH_API_URL);

  return (
    <ConfigProvider theme={theme === "light" ? antdThemeLight : antdThemeDark}>
      <AntApp>
        <TopPromotionBar />
        <Seo />
        {loading ? (
          <Loader />
        ) : (
          <Routes>
            {/* Private routers */}
            {flatRoutes.map(({ path, element: Element, roles }, idx) => (
              <Route
                path={path}
                key={idx + path}
                element={
                  <AuthGuard roles={roles}>
                    {Element ? (
                      <Suspense fallback={<Loader />}>
                        <Element />
                      </Suspense>
                    ) : (
                      <NotFound />
                    )}
                  </AuthGuard>
                }
              />
            ))}

            {/* Public routers */}
            {PUBLIC_ROUTES.map(({ path, element: Element }, idx) => (
              <Route
                path={path}
                key={idx + path}
                element={
                  <Suspense fallback={<Loader />}>
                    <Element />
                  </Suspense>
                }
              />
            ))}
          </Routes>
        )}
      </AntApp>
    </ConfigProvider>
  );
};

export default App;
